/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function CaretCircleDoubleRight(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M201.53906,54.46094a103.95314,103.95314,0,1,0,0,147.07812A104.12262,104.12262,0,0,0,201.53906,54.46094Zm-75.88281,79.19531-32,32a7.99915,7.99915,0,0,1-11.3125-11.3125L108.6875,128,82.34375,101.65625a7.99915,7.99915,0,0,1,11.3125-11.3125l32,32A7.99708,7.99708,0,0,1,125.65625,133.65625Zm56,0-32,32a7.99915,7.99915,0,0,1-11.3125-11.3125L164.6875,128l-26.34375-26.34375a7.99915,7.99915,0,0,1,11.3125-11.3125l32,32A7.99708,7.99708,0,0,1,181.65625,133.65625Z" />
    </Svg>
  );
}

export default CaretCircleDoubleRight;
